import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../UI/Button';
import './TotpSetup.css';

const TotpSetup = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { totpState, setupTotp } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (code.length !== 6 || !/^\d{6}$/.test(code)) {
      setError('Please enter a valid 6-digit code');
      return;
    }

    setLoading(true);
    const result = await setupTotp(code);
    if (!result.success) {
      setError(result.error || 'Invalid code, please try again');
    }
    setLoading(false);
  };

  return (
    <div className="totp-container">
      <div className="totp-card">
        <div className="totp-card__header">
          <h2>Set Up Two-Factor Authentication</h2>
          <p>Scan the QR code below with your authenticator app (e.g. Google Authenticator, Authy), then enter the 6-digit code to confirm.</p>
        </div>

        <div className="totp-card__qr">
          <QRCodeSVG value={totpState.totpUri} size={180} />
        </div>

        {error && (
          <div className="totp-card__error">{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="totp-code" className="form-label">
              Verification Code
            </label>
            <input
              id="totp-code"
              type="text"
              inputMode="numeric"
              pattern="\d{6}"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              className="form-input totp-card__code-input"
              placeholder="000000"
              disabled={loading}
              autoComplete="one-time-code"
            />
          </div>

          <Button
            type="submit"
            variant="primary"
            size="large"
            loading={loading}
            disabled={loading}
            className="totp-card__submit"
          >
            Confirm & Continue
          </Button>
        </form>
      </div>
    </div>
  );
};

export default TotpSetup;
